<template>
  <div class="asset-receive">
    <div class="asset-summary">
      <!-- 资产概览 -->
      <dna-asset-summary class="asset-summary"></dna-asset-summary>
    </div>
    <div class="asset-tabs">
      <dna-nav-second
        @navSecondHandle="navSecondHandle"
        :dataSource="[
          {
            text: $t('asset.receive'),
            value: '/asset/dlpreceive'
          },
          {
            text: $t('asset.send'),
            value: '/asset/dlpsend'
          }
        ]"
        :currIndex="4"
      ></dna-nav-second>
      <!--  -->
    </div>
    <div class="asset-receive-content">
      <dna-wrapper>
        <!-- 表格 -->
        <dna-asset-swap-form></dna-asset-swap-form>
      </dna-wrapper>
    </div>
  </div>
</template>

<script>
import dnaAssetSummary from "@/components/DlpAssetSummary/AssetSummary.vue";
import dnaAssetSwapForm from "@/components/DlpAssetSwapForm/AssetSwapForm.vue";
import dnaNavSecond from "@/components/DlpNavSecond/NavSecond.vue";
import UTIL from "@/util/util.js";
export default {
  data() {
    return {};
  },
  methods: {
    formatNum(str) {
      return UTIL.formatNumber(str);
    },
    navSecondHandle(item, index) {
      //alert(`item:${JSON.stringify(item)},index:${index}`);
      this.$router.push(item.value).catch(err => {});
    }
  },
  components: {
    dnaAssetSummary,
    dnaAssetSwapForm,
    dnaNavSecond
  }
};
</script>

<style lang="less" scoped>
@import url("./AssetSwap.less");
</style>